import { createContext, useCallback, useContext, useMemo, useRef, type ReactNode } from 'react';

type InventoryTransactionsHubContextValue = {
  registerRefetch: (refetch: () => void) => void;
  refetchList: () => void;
};

const InventoryTransactionsHubContext = createContext<InventoryTransactionsHubContextValue | null>(
  null
);

export const InventoryTransactionsHubProvider = ({ children }: { children: ReactNode }) => {
  const refetchRef = useRef<(() => void) | null>(null);

  const registerRefetch = useCallback((refetch: () => void) => {
    refetchRef.current = refetch;
  }, []);

  const refetchList = useCallback(() => {
    refetchRef.current?.();
  }, []);

  const value = useMemo(
    () => ({ registerRefetch, refetchList }),
    [registerRefetch, refetchList]
  );

  return (
    <InventoryTransactionsHubContext.Provider value={value}>
      {children}
    </InventoryTransactionsHubContext.Provider>
  );
};

export const useInventoryTransactionsHub = () => {
  const context = useContext(InventoryTransactionsHubContext);
  if (!context) {
    throw new Error(
      'useInventoryTransactionsHub must be used within InventoryTransactionsHubProvider'
    );
  }
  return context;
};
